import React from "react"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import { injectIntl } from "gatsby-plugin-react-intl"
import PricingData from "../../content/pricing/index.json";
import HeroPagesCenter from "../../components/heroes/hero-pages-center";
import {Row, Col, Container} from "react-bootstrap";
import DemoData from "../../content/demo/index.json"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import ImageFluid from "../../components/misc/image-fluid"
import QuoteRequestDemoForm from "../../components/forms/quote-request-demo-form"
import TickerData from "../../content/home/ticker.json";
import ClientsTicker from "../../components/misc/clients-ticker";
import CTAData from "../../content/pricing/cta.json";
import SimpleCTA from "../../components/ctas/simple-cta";
// import FeaturesData from "../../content/pricing/features.json";
// import ResellersData from "../../content/pricing/resellers.json";
// import PricingPlans from "../../components/pricing/plans";
// import FeatureComparison from "../../components/pricing/features";
// import SMSCalculator from "../../components/pricing/sms-calculator";
// import EmailPricing from "../../components/pricing/email-pricing";
// import Resellers from "../../components/pricing/resellers";
// import AddonsPricing from "../../components/pricing/addons-pricing"

const PricingIndexPage = ({ intl, location }) => (
  <Layout>
      <Seo lang={intl.locale}
           title={PricingData[intl.locale].title}
           description={PricingData[intl.locale].text}
           pathname={location.pathname}/>
      <HeroPagesCenter
        theme={`primary`}
        content={PricingData[intl.locale]}
      />
      <div className={`demo`}>
          <Container>
              <Row noGutters={true}>
                  <Col md={4}>
                      <div className={`top-small-overflow-wrapper`}>
                          <div className={`demo-content`}>
                              <div className={`title`}>{PricingData[intl.locale].quoteRequest.title}</div>
                              <div className={`reasons`}>
                                  {PricingData[intl.locale].quoteRequest.reasons.map((reason, i) => {
                                      return (
                                        <div key={i} className={`reason`}>
                                            <FontAwesomeIcon icon="arrow-right"/>
                                            {reason.text}
                                        </div>
                                      )
                                  })}
                              </div>
                              <div className={`image`}>
                                  <ImageFluid alt={``} filename={PricingData[intl.locale].quoteRequest.image}/>
                              </div>
                          </div>
                      </div>
                  </Col>
                  <Col md={8}>
                      <div className={`top-overflow-wrapper`}>
                          <QuoteRequestDemoForm/>
                      </div>
                  </Col>
              </Row>
              <div className={`mb-5`}>
                  <SimpleCTA theme={`primary`} content={CTAData[intl.locale]}/>
              </div>
              <ClientsTicker content={TickerData[intl.locale]}/>
          </Container>
      </div>
      {/*<div className={`top-overflow-wrapper`}>*/}
      {/*    <PricingPlans*/}
      {/*      currencies={PricingData[intl.locale].currencies}*/}
      {/*      plans={PricingData[intl.locale].plans}*/}
      {/*    />*/}
      {/*    <AddonsPricing/>*/}
      {/*    <Container>*/}
      {/*        <Row>*/}
      {/*            <Col lg={8}>*/}
      {/*                <EmailPricing/>*/}
      {/*            </Col>*/}
      {/*            <Col lg={4}>*/}
      {/*                <Resellers content={ResellersData[intl.locale]}/>*/}
      {/*            </Col>*/}
      {/*        </Row>*/}
      {/*    </Container>*/}
      {/*    <SMSCalculator/>*/}
      {/*    <Container>*/}
      {/*        <FeatureComparison content={FeaturesData[intl.locale]}/>*/}
      {/*        <div className={`mb-5`}>*/}
      {/*            <SimpleCTA theme={`primary`} content={CTAData[intl.locale]}/>*/}
      {/*        </div>*/}
      {/*    </Container>*/}
      {/*    <ClientsTicker content={TickerData[intl.locale]}/>*/}
      {/*</div>*/}
  </Layout>
)

export default injectIntl(PricingIndexPage)
